import { render, staticRenderFns } from "./IconToogleCam.vue?vue&type=template&id=a5f71ac6"
import script from "./IconToogleCam.vue?vue&type=script&lang=js"
export * from "./IconToogleCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports